/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Save_Id_ReservedInputs */



/**
* | output |
* | --- |
* | "This model ID belongs to a built-in model. Choose another one." |
*
* @param {Private_Models_Save_Id_ReservedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_save_id_reserved = /** @type {((inputs?: Private_Models_Save_Id_ReservedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Save_Id_ReservedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese Modell-ID gehört zu einem eingebauten Modell. Wählen Sie eine andere.")
	return /** @type {LocalizedString} */ ("This model ID belongs to a built-in model. Choose another one.")
});